// Small shared helpers for the Google / Meta integration panels.
import React from "react";

const STATUS_LABELS = {
  connected: ["Connected", "var(--success)"],
  needs_reauth: ["Needs reconnect", "var(--warning)"],
  disconnected: ["Disconnected", "var(--muted)"],
  not_connected: ["Not connected", "var(--muted)"],
};

export function StatusPill({ status, testId }) {
  const [label, color] = STATUS_LABELS[status] || [status || "Unknown", "var(--muted)"];
  return (
    <span
      data-testid={testId}
      style={{ fontSize: 11, padding: "4px 8px", borderRadius: 6, border: `1px solid ${color}`, color, whiteSpace: "nowrap" }}
    >
      {label}
    </span>
  );
}

export function formatWhen(value) {
  if (!value) return "never";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
}

export function errorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join("; ");
  return detail || fallback;
}
